module.exports = __webpack_public_path__ + "static/media/meteringicon02@3x.0529094b.png";